import { IReduxStore } from 'Redux/Store/IReduxStore';

export const getActiveMenuTab = (state: IReduxStore) => state.global.activeSideMenuTab;